export default {
  List: {
    Department: "Cơ cấu tổ chức",
    AddDepartment: "Thêm phòng ban",
    SearchText: "Tìm theo tên phòng ban",
    AllStatus: "Tất cả trạng thái",
    AddOrganization:"Thêm đơn vị",
    SyncData:"Đồng bộ"
  },
  Detail: {
    EmulationTitleName: "Tên danh hiệu",
    ObjectName: "Đối tượng",
    ObjectType: "Đối tượng"
  }
}